// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__26sRk","header":"Messages_header__2KtmE"};